###
# Параметры компонента:
#   type: ['toggle', 'select', 'text', 'image', 'color']
#   name: string
#   text: string
#   values: [Object]
###
App.GeneralParametersComponent = Em.Component.extend
  organization:       null
  fileInput:          null
  onParameterChanged: null
  isLoading:     false
  onAddressEditClicked: null

  imageStyle: (->
    logo = @get('organization.logo_medium_url')

    if logo?
      return "background-color: grey; background-image: url(#{ logo })".htmlSafe()
    else
      return "background-image: url(#{ @get('organization.avatarPlaceholder') })".htmlSafe()
  ).property('organization', 'organization.logo_medium_url', 'isLoading')

  actions:
    openFileDialog: ->
      @get('fileInput').send('openDialog')
      false

    uploadPhoto: (file) ->
      @set('isLoading', true)
      @get('organization').uploadLogo(file)
      .then =>
        @set('isLoading', false)
        @sendAction('onParameterChanged')
      false


    removePhoto: () ->
      if confirm 'Удалить установленное изображение?'
        @get('organization').removeLogo()
        @sendAction 'onParameterChanged'

      false


    textValueChanged: ->
      return if not @get('organization.name')?.trim()
      @get('organization').save()
      @sendAction('onParameterChanged')

    redirectToSiteNameSettings: ->
      @sendAction('onAddressEditClicked')


